/**
 * `game_key`。**唯一の識別子**（CLAUDE.md の規則1）。
 * D1 の `game_key` / `src/games/crates/` / `src/locales/<lang>/crates.json` /
 * `public/assets/crates/` / localStorage の `crates.*` を全部この文字列で揃える。
 *
 * ⚠️ 表示名は「箱プッシュ！」、素材フォルダは `05_BoxPush` だが、**内部名は `crates`**
 *   （[docs/GAMES-ROADMAP.md](../../../docs/GAMES-ROADMAP.md) の10本構想で確定済み・2026-08-16 にユーザーが選択）。
 *   公開後は**変えられない**——D1 の行・保存キー・アセットのパスが全部この値で書かれるため。
 *
 * Phaser を引かない軽いモジュールにしておくこと（登録簿から静的に import される）。
 */
export const GAME_KEY = 'crates';
